"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Iconclient;
var React = _interopRequireWildcard(require("react"));
var _internal = require("@aws-amplify/ui-react/internal");
var _uiReact = require("@aws-amplify/ui-react");
var _excluded = ["overrides"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Iconclient(props) {
  var overridesProp = props.overrides,
    rest = _objectWithoutProperties(props, _excluded);
  var variants = [{
    overrides: {
      Vector38921321: {},
      Vector38921322: {},
      "Group 17937": {},
      Iconclient: {}
    },
    variantValues: {
      size: "Default"
    }
  }, {
    overrides: {
      Vector38921321: {
        width: "33px",
        height: "19.8px",
        viewBox: {
          minX: 0,
          minY: 0,
          width: 32.99658203125,
          height: 19.798095703125
        },
        paths: [{
          d: "M13.1987 0C5.90926 0 0 5.90926 0 13.1987C0 16.8435 2.95463 19.7981 6.59935 19.7981L26.3974 19.7981C30.0422 19.7981 32.9968 16.8435 32.9968 13.1987C32.9968 5.90926 27.0874 0 19.7981 0L13.1987 0Z",
          fill: "rgba(174,179,183,1)",
          fillRule: "evenodd"
        }]
      },
      Vector38921322: {
        width: "23.1px",
        height: "23.1px",
        viewBox: {
          minX: 0,
          minY: 0,
          width: 23.09765625,
          height: 23.09771728515625
        },
        paths: [{
          d: "M11.5489 0C5.1706 0 0 5.17059 0 11.5489C0 17.9271 5.1706 23.0977 11.5489 23.0977C17.9271 23.0977 23.0977 17.9271 23.0977 11.5489C23.0977 5.17059 17.9271 0 11.5489 0Z",
          fill: "rgba(250,250,250,1)",
          fillRule: "evenodd"
        }]
      },
      "Group 17937": {
        width: "33px",
        height: "36.3px",
        top: "4.24px",
        left: "5.82px"
      },
      Iconclient: {
        width: "45px",
        height: "45px"
      }
    },
    variantValues: {
      size: "Small"
    }
  }];
  var overrides = (0, _internal.mergeVariantsAndOverrides)((0, _internal.getOverridesFromVariants)(variants, props), overridesProp || {});
  return /*#__PURE__*/React.createElement(_uiReact.View, _extends({
    width: "85px",
    height: "85px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Iconclient"), rest), /*#__PURE__*/React.createElement(_uiReact.View, _extends({
    padding: "0px 0px 0px 0px",
    width: "62.33px",
    height: "68.56px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "8px",
    left: "11px"
  }, (0, _internal.getOverrideProps)(overrides, "Group 17937")), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "62.33px",
    height: "37.4px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 62.3271484375,
      height: 37.3963623046875
    },
    paths: [{
      d: "M24.9309 0C11.1619 0 0 11.1619 0 24.9309C0 31.8156 5.58097 37.3964 12.4654 37.3964L49.8618 37.3964C56.7464 37.3964 62.3272 31.8156 62.3272 24.9309C62.3272 11.1619 51.165 0 37.3963 0L24.9309 0Z",
      fill: "rgba(174,179,183,1)",
      fillRule: "evenodd"
    }],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "45.45%",
    bottom: "0%",
    left: "0%",
    right: "0%"
  }, (0, _internal.getOverrideProps)(overrides, "Vector38921321"))), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "43.63px",
    height: "43.63px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 43.62890625,
      height: 43.62908935546875
    },
    paths: [{
      d: "M21.8145 0C9.76668 0 0 9.76668 0 21.8145C0 33.8624 9.76668 43.6291 21.8145 43.6291C33.8624 43.6291 43.6291 33.8624 43.6291 21.8145C43.6291 9.76668 33.8624 0 21.8145 0Z",
      fill: "rgba(250,250,250,1)",
      fillRule: "evenodd"
    }],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "0%",
    bottom: "36.36%",
    left: "15%",
    right: "15%"
  }, (0, _internal.getOverrideProps)(overrides, "Vector38921322")))));
}